import { SvgIconProps } from "@mui/material";

// A tall main pane on the left, a 2x2 grid of small panes on the right.
export const OneVertPlusFourIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="9" height="20" rx="1.5" />
    <rect x="13" y="2" width="4" height="9.5" rx="1" />
    <rect x="18" y="2" width="4" height="9.5" rx="1" />
    <rect x="13" y="12.5" width="4" height="9.5" rx="1" />
    <rect x="18" y="12.5" width="4" height="9.5" rx="1" />
  </svg>
);
